export default "__VITE_ASSET__BulR5n2T__"